import React, { Component } from 'react';
import './App.css';

class Skills extends Component {
  render() {
    return (
        <div>


          <table id="skills">
          	<tr>
       			<th>Mobile</th>
       			<th>FrontEnd</th>
       			<th>BackEnd</th>
       		</tr>
          	<tr>
          		<td>Android</td>
          		<td>ReactJs</td>
          		<td>NodeJs</td>
          	</tr>
          	<tr>
          		<td>Swift(IOS)</td>
          		<td>VueJs</td>
          		<td>PHP/Laravel/Yii</td>
          	</tr>
          	<tr>
          		<td>React-Native</td>
          		<td>Angular</td>
          		<td>RubyOnRails</td>
          	</tr>
          	<tr>
          		<td>Vue-Native</td>
          	</tr>
          </table>
          <br/>
          <br/>
          <table id="languages">
         	<tr>
         		<th></th>
         		<th>Languages:</th>
         		<th></th>
         	</tr>
          	<tr>
          		<td>Java</td>
          		<td>Kotlin</td>
          		<td>Ruby</td>
          	</tr>
          	<tr>
          		<td>Python</td>
          		<td>C/C++</td>
          		<td>C#</td>
          	</tr>
          </table>
          <ul>
          	
          </ul>
        </div>
    );
  }
}

export default Skills;
